import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Divider from "@mui/material/Divider";
import Typography from "../../../../fhg/components/Typography";
import { IMSContext } from "../../list/IMSFormCategorySelect";
import IMSFormCategorySelect from "../../list/IMSFormCategorySelect";
import RequiredFieldsAlert from "../RequiredFieldsAlert";
import { useAssetDrawerStore } from "./assetDrawerStore";
import { BeatLoader } from "react-spinners";

const useStyles = makeStyles(
  (theme) => ({
    backgroundStyleIMSForm: {
      backgroundColor: theme.palette.environment.light.level0.base,
      padding: theme.spacing(2, 3, 2),
      overflow: "auto",
      height: "100%",
      width: "150%",
    },
    buttonContainer: {
      marginTop: "25px",
    },
    formButton: {
      height: 40,
      width: "60%",
    },
    submitButton: {
      height: 40,
      width: "100%",
    },
    divider: {
      marginTop: "20px",
      maxWidth: "60.5%",
    },
    buttonWrapper: {
      position: "relative",
      display: "inline-block",
      width: "60.5%",
    },
    spinnerPosition: {
      position: "absolute",
      top: "calc(100% + 30px)",
      left: "50%",
      transform: "translateX(-50%)",
    },
  }),
  { name: "IMSFormTab" }
);

function IMSFormTab({ evalItem, customerNumber, evaluationData }) {
  const classes = useStyles();
  const { setSaveForm, isSavingIMS } = useAssetDrawerStore();
  const [successFormSub, setSuccessFormSub] = useState(false);
  const [errorFormSub, setErrorsFormSub] = useState(false);
  const [isIMSFieldRequired, setIsIMSFieldRequired] = useState(false);
  const [openRequiredModel, setOpenRequiredModel] = useState(false);
  
  // Use provided evaluationData instead of fetching again
  const { estimatedHammer, jobCodeData, nominationValue } = useContext(IMSContext);

  console.log({ evalItem });

  const handleSaveForm = () => {
    const hasAllRequiredFields =
      evaluationData?.item?.sticker_id &&
      jobCodeData &&
      nominationValue !== "0" &&
      !!String(estimatedHammer || '').trim();

    if (!hasAllRequiredFields) {
      setIsIMSFieldRequired(true);
      setOpenRequiredModel(true);
      return;
    }

    setSaveForm(true);
  };

  const handleSubmitFormToIMS = async () => {};

  const handleAlertClose = () => {
    setErrorsFormSub(false);
    setSuccessFormSub(false);
  };

  return (
    <Grid
      container
      className={classes.backgroundStyleIMSForm}
      wrap={"nowrap"}
      direction={"column"}
    >
      {isSavingIMS && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.35)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2000,
        }}>
          <BeatLoader color="#4f2681" loading={true} size={20} aria-label="Saving IMS Form" />
        </div>
      )}
      
      
      <IMSFormCategorySelect
        key={evalItem?.item_id || evalItem?.id}
        customerNumber={customerNumber}
        evalItem={{ ...evalItem, itemData: evaluationData }}
      />

      <div style={{ margin: "12px 0" }}></div>
        <Divider style={{ marginTop: "20px", maxWidth: "60.5%" }} />
        <div style={{ margin: "12px 0" }}></div>
      <Grid>
        <Button
          variant={"text"}
          className={"fourth-button"}
          onClick={handleSaveForm}
          style={{ height: 40, width: "60%"}}
        >
          <Typography
            color="inherit"
            variant="button"
            id={"equipmentList.IMSformSaveButton.label"}
          />
        </Button>
      
        {isIMSFieldRequired && (
          <RequiredFieldsAlert
            imsFormData={{
              "Sticker ID": evaluationData?.item?.sticker_id,
              "Job Code": jobCodeData,
              "Nomination": nominationValue,
              "Estimated Hammer": estimatedHammer,
            }}
            onOpen={openRequiredModel}
            onClose={() => setOpenRequiredModel(false)}
          />
        )}
      </Grid>
    </Grid>
  );
}

IMSFormTab.propTypes = {
  evalItem: PropTypes.object.isRequired,
  customerNumber: PropTypes.string,
  evaluationData: PropTypes.object,
};

export default IMSFormTab;